module.exports = __webpack_public_path__ + "assets/19ab3e4c3bdf9c00d88d69686e273726.png";